import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss'],
})
export class InstagramComponent implements OnInit, AfterViewInit {
  @Input() data: any = undefined;
  public res: any = ''
  public height = '';

  constructor(
    private paramSv: ParamServicesService
  ) { }

  async ngAfterViewInit() {
    
  }

  async ngOnInit() {
    const data = await this.paramSv.getOnlyParam('instagram');
    if(data){
      this.res = JSON.parse(data);
      this.height = `${this.res.height}rem`;
    }
  }

}
